import { useRouter } from 'next/router';
import React from 'react';

import { Button } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import { fullDealLandingPageRoute } from '@src/shared/constants/pageRoutes';

import { FULL_DEAL_ENTRY_POINT_TEXTS, FULL_DEAL_WEB_TO_WEB_LINKS, FULL_DEAL_WEB_TO_WEB_SOURCE } from '../../config';
import { buildHasOfferLinkForFullDeal, openMobileApp } from '../../lib';
import { ToFullDealAdvertisingButton } from '../ToFullDealAdvertisingButton/ToFullDealAdvertisingButton';

export interface FullDealOfferActionsProps {
  amount: number;
  term: number;
  hasIssuedMicrocreditDeals: boolean;
  toFullDealButtonText: string;
  toFullDealButtonColor?: ButtonProps['color'];

  seoHeading?: string;

  onMyLoansClick?: (event: React.SyntheticEvent, seoHeading: string) => void;
}

export const FullDealOfferActions = ({
  amount,
  term,
  hasIssuedMicrocreditDeals,
  toFullDealButtonText,
  toFullDealButtonColor = 'gray',
  seoHeading,

  onMyLoansClick = openMobileApp,
}: FullDealOfferActionsProps) => {
  const { asPath } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');
  const isLandingPage = pathWithoutQuery.includes(fullDealLandingPageRoute);

  const linkWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_LINKS.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_LINKS.FROM_REFERAL_VITRINA;

  const sourceWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_REFERAL_VITRINA;

  return (
    <>
      <ToFullDealAdvertisingButton
        variant="primary"
        link={buildHasOfferLinkForFullDeal({
          link: linkWebToWeb,
          amount,
          term,
          ...(isLandingPage && {
            showAuth: true,
            referrer: asPath,
          }),
        })}
        color={toFullDealButtonColor}
        size={52}
        source={sourceWebToWeb}
        linkTarget="_self"
      >
        {toFullDealButtonText}
      </ToFullDealAdvertisingButton>

      {hasIssuedMicrocreditDeals && (
        <Button size={52} color="gray" onClick={(e) => onMyLoansClick(e, seoHeading)}>
          {FULL_DEAL_ENTRY_POINT_TEXTS.mobileAppButtonText}
        </Button>
      )}
    </>
  );
};
